export const list = {
  "open" :[
    {
      id : 1,
      nameJP : "キャストドリンク",
      doronType : "doron",
      price : 30,
      period : 60,
      withAnimation: false
    },
    {
      id : 2,
      nameJP : "花束",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: false
    },
    {
      id : 23,
      nameJP : "誕生日ケーキ",
      doronType : "doron",
      price : 100,
      period : 60,
      withAnimation: false
    },
    {
      id : 3,
      nameJP : "ぬいぐるみ",
      doronType : "doron",
      price : 120,
      period : 120,
      withAnimation: false
    },
    {
      id : 4,
      nameJP : "クラッカー",
      doronType : "doron",
      price : 300,
      period : 180,
      withAnimation: false
    },
     {
      id : 5,
      nameJP : "スパークル",
      doronType : "doron",
      price : 480,
      period : 300,
      withAnimation: true
    },
    {
      id : 17,
      nameJP : "ドーナツ",
      doronType : "doron",
      price : 700,
      period : 300,
      withAnimation: true
    },
    {
      id : 6,
      nameJP : "打ち上げ花火",
      doronType : "doron",
      price : 1200,
      period : 600,
      withAnimation: true
    },
     {
      id : 7,
      nameJP : "紙吹雪",
      doronType : "doron",
      price : 2400,
      period : 1200,
      withAnimation: true
    },
    {
      id : 19,
      nameJP : "ハート",
      doronType : "doron",
      price : 3600,
      period : 120,
      withAnimation: true
    },
    {
      id : 8,
      nameJP : "ミラーボール",
      doronType : "doron",
      price : 4800,
      period : 1800,
      withAnimation: true
    },
    {
      id : 9,
      nameJP : "キャストドリンク",
      doronType : "freeDoron",
      price : 30,
      period : 10,
      withAnimation: false
    },
    {
      id : 10,
      nameJP : "花束",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: false
    },
    {
      id : 24,
      nameJP : "誕生日ケーキ",
      doronType : "freeDoron",
      price : 100,
      period : 20,
      withAnimation: false
    },
    {
      id : 11,
      nameJP : "ぬいぐるみ",
      doronType : "freeDoron",
      price : 120,
      period : 20,
      withAnimation: false
    },
    {
      id : 12,
      nameJP : "クラッカー",
      doronType : "freeDoron",
      price : 300,
      period : 20,
      withAnimation: false
    },
     {
      id : 13,
      nameJP : "スパークル",
      doronType : "freeDoron",
      price : 480,
      period : 30,
      withAnimation: true
    },
    {
      id : 18,
      nameJP : "ドーナツ",
      doronType : "freeDoron",
      price : 700,
      period : 300,
      withAnimation: true
    },
    {
      id : 14,
      nameJP : "打ち上げ花火",
      doronType : "freeDoron",
      price : 1200,
      period : 60,
      withAnimation: true
    },
    {
      id : 15,
      nameJP : "紙吹雪",
      doronType : "freeDoron",
      price : 2400,
      period : 120,
      withAnimation: true
    },
    {
      id : 20,
      nameJP : "ハート",
      doronType : "freeDoron",
      price : 3600,
      period : 120,
      withAnimation: true
    },
    {
      id : 16,
      nameJP : "ミラーボール",
      doronType : "freeDoron",
      price : 4800,
      period : 180,
      withAnimation: true
    },
  ],
  "individual" :[
    {
      id : 1001,
      nameJP : "キャストドリンク",
      doronType : "doron",
      price : 30,
      period : 60,
      withAnimation: false
    },
    {
      id : 1002,
      nameJP : "花束",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: false
    },
    {
      id : 1003,
      nameJP : "ぬいぐるみ",
      doronType : "doron",
      price : 120,
      period : 120,
      withAnimation: false
    },
    {
      id : 1004,
      nameJP : "クラッカー",
      doronType : "doron",
      price : 300,
      period : 180,
      withAnimation: false
    },
    {
      id : 1005,
      nameJP : "愛してる",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: true
    },
    {
      id : 1006,
      nameJP : "好き",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: true
    },
    {
      id : 1007,
      nameJP : "かわいいよ",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: true
    },
    {
      id : 1008,
      nameJP : "本気になってもいい？",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: true
    },
     {
      id : 1009,
      nameJP : "俺以外見るな",
      doronType : "doron",
      price : 50,
      period : 60,
      withAnimation: true
    },
    {
      id : 1010,
      nameJP : "宝石",
      doronType : "doron",
      price : 3000,
      period : 1200,
      withAnimation: true
    },
    {
      id : 1011,
      nameJP : "キャストドリンク",
      doronType : "freeDoron",
      price : 30,
      period : 10,
      withAnimation: false
    },
    {
      id : 1012,
      nameJP : "花束",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: false
    },
    {
      id : 1013,
      nameJP : "ぬいぐるみ",
      doronType : "freeDoron",
      price : 120,
      period : 20,
      withAnimation: false
    },
    {
      id : 1014,
      nameJP : "クラッカー",
      doronType : "freeDoron",
      price : 300,
      period : 20,
      withAnimation: false
    },
    {
      id : 1015,
      nameJP : "愛してる",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: true
    },
    {
      id : 1016,
      nameJP : "好き",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: true
    },
    {
      id : 1017,
      nameJP : "かわいいよ",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: true
    },
    {
      id : 1018,
      nameJP : "本気になってもいい？",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: true
    },
    {
      id : 1019,
      nameJP : "俺以外見るな",
      doronType : "freeDoron",
      price : 50,
      period : 10,
      withAnimation: true
    },
    {
      id : 1020,
      nameJP : "宝石",
      doronType : "freeDoron",
      price : 3000,
      period : 120,
      withAnimation: true
    },
  ]
}